import { ShippingMethod } from "../../models/step-shipping/models/step-shipping/shipping-methods.js";
const isDelivery = (method) => method === ShippingMethod.Delivery;
const isDeliveryExpress = (method) => method === ShippingMethod.DeliveryExpress;
const isNearestPickup = (method) => method === ShippingMethod.NearestPickup;
const isPickupStore = (method) => method === ShippingMethod.Pickup;
const isPickupPoint = (method) => method === ShippingMethod.PickupPoint;
const isDeliveryPremium = (method) => method === ShippingMethod.DeliveryPremium;
const isDeliveryResponsible = (method) => method === ShippingMethod.DeliveryResponsible;
export {
  isDelivery,
  isDeliveryExpress,
  isDeliveryPremium,
  isDeliveryResponsible,
  isNearestPickup,
  isPickupPoint,
  isPickupStore
};
//# sourceMappingURL=shipping-method.js.map
